import { DeepReadonly } from 'types';
import { deepFreeze } from '../utils/deepFreeze.js';

export const universities: DeepReadonly<string[]> = deepFreeze([
  'Abertay University',
  'Aberystwyth University',
  'AECC University College',
  'Aga Khan University',
  'Anglia Ruskin University',
  'Arden University',
  'Aston University',
  'BPP University',
  'Bangor University',
  'Bath Spa University',
  'Bermuda College',
  'Birkbeck, University of London',
  'Birmingham City University',
  'Bishop Grosseteste University',
  'Blackpool and The Fylde College',
  'Booth School of Business',
  'Bournemouth University',
  'Brunel University London',
  'Buckinghamshire New University',
  'CU London',
  'Canterbury Christ Church University',
  'Cardiff Metropolitan University',
  'Cardiff University',
  'Centre for Medieval and Renaissance Studies',
  'City, University of London',
  'Conservatoire for Dance and Drama',
  'Cornwall College',
  'Courtauld Institute of Art',
  'Coventry University',
  'Cranfield University',
  'De Montfort University',
  'Edge Hill University',
  'Edinburgh Napier University',
  'Falmouth University',
  'Glasgow Caledonian University',
  'Goldsmiths, University of London',
  'Grimsby Institute of Further & Higher Education',
  'Guildhall School of Music and Drama',
  'Harper Adams University',
  'Hartpury University and Hartpury College',
  'Heriot-Watt University',
  'Hull College',
  'Hult International Business School',
  'Imperial College London',
  'Institute of Cancer Research',
  'Keele University',
  'Kingston University',
  "King's College London",
  'LAMDA - London Academy of Music and Dramatic Art',
  'Lancaster University',
  'Leeds Arts University',
  'Leeds Beckett University',
  'Leeds Conservatoire',
  'Leeds Trinity University',
  'Liverpool Hope University',
  'Liverpool John Moores University',
  'Liverpool School of Tropical Medicine',
  'London Business School',
  'London Institute of Banking and Finance',
  'London Metropolitan University',
  'London School of Economics and Political Science',
  'London School of Hygiene and Tropical Medicine',
  'London South Bank University',
  'Loughborough University',
  'Manchester Metropolitan University',
  'Middlesex University',
  'National Film & Television School',
  'New College, Durham',
  'Newcastle College',
  'Newcastle University',
  'Newman University, Birmingham',
  'Northumbria University',
  'Norwich University of the Arts',
  'Nottingham Trent University',
  'Oxford Brookes University',
  'Plymouth College of Art',
  'Plymouth Marjon University',
  'Queen Margaret University',
  'Queen Mary, University of London',
  'Ravensbourne University London',
  'Regent College London',
  "Regent's University London",
  'Richmond, The American International University in London',
  'Robert Gordon University',
  'Roehampton University',
  'Rose Bruford College',
  'Royal Academy of Dramatic Art',
  'Royal Academy of Music',
  'Royal Agricultural University',
  'Royal Central School of Speech and Drama',
  'Royal College of Art',
  'Royal College of Music',
  'Royal Conservatoire of Scotland',
  'Royal Holloway, University of London',
  'Royal Northern College of Music',
  'Royal Veterinary College',
  'Sheffield Hallam University',
  "Scotland's Rural College",
  'SOAS University of London',
  'Solent University',
  "St George's, University of London",
  "St Mary's University, Twickenham",
  'Staffordshire University',
  'Swansea University',
  'Teesside University',
  'The Arts University Bournemouth',
  'The Glasgow School of Art',
  'The Liverpool Institute for Performing Arts',
  'The Open University',
  'Trinity Laban Conservatoire of Music and Dance',
  'Ulster University',
  'University College Birmingham',
  'University College London',
  'University College of Estate Management',
  'University College of Osteopathy',
  'University for the Creative Arts',
  'University of Aberdeen',
  'University of Bath',
  'University of Bedfordshire',
  'University of Birmingham',
  'University of Bolton',
  'University of Bradford',
  'University of Brighton',
  'University of Bristol',
  'University of Buckingham',
  'University of Cambridge',
  'University of Central Lancashire',
  'University of Chester',
  'University of Chichester',
  'University of Cumbria',
  'University of Derby',
  'University of Dundee',
  'University of Durham',
  'University of East Anglia',
  'University of East London',
  'University of Edinburgh',
  'University of Essex',
  'University of Exeter',
  'University of Glasgow',
  'University of Gloucestershire',
  'University of Greenwich',
  'University of Hertfordshire',
  'University of Huddersfield',
  'University of Hull',
  'University of Kent',
  'University of Law',
  'University of Leeds',
  'University of Leicester',
  'University of Lincoln',
  'University of Liverpool',
  'University of London',
  'University of Manchester',
  'University of Northampton',
  'University of Notre Dame',
  'University of Nottingham',
  'University of Oxford',
  'University of Plymouth',
  'University of Portsmouth',
  'University of Reading',
  'University of Salford',
  'University of Sheffield',
  'University of South Wales',
  'University of Southampton',
  'University of St Andrews',
  'University of Stirling',
  'University of Strathclyde',
  'University of Suffolk',
  'University of Sunderland',
  'University of Surrey',
  'University of Sussex',
  'University of Wales, Trinity Saint David',
  'University of Wales',
  'University of Warwick',
  'University of West London',
  'University of Westminster',
  'University of Winchester',
  'University of Wolverhampton',
  'University of Worcester',
  'University of York',
  'University of the Arts London',
  'University of the Highlands & Islands',
  'University of the West of England, Bristol',
  'University of the West of Scotland',
  'Warwickshire College',
  'Wrexham Glyndŵr University',
  'Writtle University College',
  'York St John University',
  "Queen's University Belfast",
]);
